export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/vector_tracing.5466ffc.svg";